import axios from 'axios';
import { API_BASE_URL } from '../config/api';

/**
 * Backend base URL for media (images). In dev, API is :3001 while CRA is :3000.
 */
export function getApiBaseUrl() {
  const fromAxios = axios.defaults?.baseURL;
  if (fromAxios) return String(fromAxios).replace(/\/$/, '');
  return API_BASE_URL.replace(/\/$/, '');
}

/**
 * Turn stored vision image paths into a full URL on the API host.
 * Accepts `/generated/foo.png`, legacy Windows paths, or absolute http(s) URLs.
 */
export function resolveMediaUrl(url) {
  if (!url) return null;
  const raw = String(url).trim();
  if (!raw) return null;
  if (/^https?:\/\//i.test(raw) || /^data:/i.test(raw)) return raw;

  const normalized = raw.replace(/\\/g, '/');
  let path = normalized;
  const lower = normalized.toLowerCase();
  const genIdx = lower.lastIndexOf('generated/');
  if (genIdx >= 0) {
    path = `/${normalized.slice(genIdx)}`;
  } else if (!path.startsWith('/')) {
    path = `/${path}`;
  }

  const base = getApiBaseUrl();
  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
}
